import React from 'react';

/**
 * Minimal SVG icon set (Heroicons-inspired) for branding-driven UI.
 * Keeps the storefront dependency-free while replacing emoji icons.
 */
const ICONS: Record<string, string> = {
  sparkles: 'M12 3v4m0 10v4M3 12h4m10 0h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6',
  leaf: 'M20 4c0 9-7 16-16 16 0-9 7-16 16-16ZM4 20c4-4 8-8 16-16',
  gem: 'M6 4h12l4 6-10 12L2 10l4-6ZM6 4l6 6 6-6M2 10h20',
  truck: 'M1 3h15v13H1zM16 8h4l3 3v5h-7ZM5.5 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM18.5 19.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z',
  'arrow-uturn-left': 'M9 15 3 9l6-6M3 9h12a6 6 0 0 1 0 12H9',
  'shield-check': 'M12 3 4 6v6c0 5 3 9 8 11 5-2 8-6 8-11V6l-8-3ZM9 12l2 2 4-4',
  'badge-check': 'M9 12l2 2 4-4M12 3 14 5l3-1 1 3 3 1-1 3 1 3-3 1-1 3-3-1-2 2-2-2-3 1-1-3-3-1 1-3-1-3 3-1 1-3 3 1z',
  'lock-closed': 'M7 11V7a5 5 0 0 1 10 0v4M5 11h14v10H5z',
  'magnifying-glass': 'M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-5-5',
  bolt: 'M13 2 3 14h7v8l10-12h-7V2Z',
  'shopping-bag': 'M5 8h14l-1.4 11.2a2 2 0 0 1-2 1.8H8.4a2 2 0 0 1-2-1.8L5 8ZM9 8V6a3 3 0 0 1 6 0v2',
  'shopping-cart': 'M3 3h2l3 14h11l3-10H6M8 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM18 21a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z',
  star: 'M12 2l3 7 7 .5-5.5 4.5 2 7L12 17l-6.5 4 2-7L2 9.5 9 9z',
};

interface IconProps {
  name: string;
  className?: string;
  size?: number;
  title?: string;
}

const Icon: React.FC<IconProps> = ({ name, className = '', size = 24, title }) => {
  const path = ICONS[name];
  if (!path) {
    // Unknown icon: render a neutral circle so layout stays stable
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden={title ? undefined : true}
        role={title ? 'img' : undefined}
      >
        {title && <title>{title}</title>}
        <circle cx="12" cy="12" r="9" />
      </svg>
    );
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden={title ? undefined : true}
      role={title ? 'img' : undefined}
    >
      {title && <title>{title}</title>}
      <path d={path} />
    </svg>
  );
};

export default Icon;
